import { render, staticRenderFns } from "./EventForm5Component.vue?vue&type=template&id=1b6640cb&"
import script from "./EventForm5Component.vue?vue&type=script&lang=js&"
export * from "./EventForm5Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports